import TransactionsModalsDepositContentFormCryptoContent from './Crypto';
import { CoinType } from '@starsoft/common/models';
import { DepositMethodId } from '@starsoft/common/enums';
import useDepositSearchParams from '../../../../../../../hooks/deposit/useDepositSearchParams';

/**
 * TransactionsModalsDepositFormContent Component
 * This component is responsible for rendering the appropriate content based on the deposit method and coin type.
 * It uses the deposit search parameters to determine which content to display.
 *
 * @returns {JSX.Element | null} The rendered component displaying the deposit form content or null if conditions are not met.
 *
 * @example
 * // Usage example:
 * <TransactionsModalsDepositFormContent />
 */
export default function TransactionsModalsDepositFormContent() {
  // Retrieve the deposit method ID and coin type from the deposit search parameters
  const { depositMethodId, coinType } = useDepositSearchParams();

  // Switch statement to determine the content to render based on the deposit method ID
  switch (depositMethodId) {
    // If the deposit method ID is 'Crypto', render the Crypto content component
    case DepositMethodId.Crypto?.toString():
      return <TransactionsModalsDepositContentFormCryptoContent />;
    // Default case to handle other deposit methods
    default: {
      // If the coin type is 'Crypto', render the Crypto content component
      if (coinType == CoinType.Crypto) {
        return <TransactionsModalsDepositContentFormCryptoContent />;
      }

      // Return null if conditions are not met
      return null;
    }
  }
}
